var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: { tabindex: "-1", role: "dialog" }
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-lg", attrs: { role: "document" } },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h5", { staticClass: "modal-title" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "maintenance.inventory.stockTaking.inventorySelectModal.title"
                    )
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body" },
              [
                _c("VueGoodTable", {
                  ref: "table",
                  attrs: {
                    columns: _vm.columnsConfig,
                    rows: _vm.store.inventories,
                    "pagination-options": _vm.paginationOptions,
                    "search-options": _vm.searchOptions,
                    "select-options": _vm.selectOptions
                  },
                  on: { "on-selected-rows-change": _vm.onSelectionChanged }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "button" },
                  on: { click: _vm.dismiss }
                },
                [_vm._v(_vm._s(_vm.$t("btnClose")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("selected", _vm.selectedInventories)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("btnAdd")))]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }